import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import App from './App';
import store from './redux/store';
import reactQueryUtils from './utils/reactQueryUtils';
import { AuthProvider } from './contexts/authContext';
import theme from './muiTheme';
import 'react-perfect-scrollbar/dist/css/styles.css';

if (import.meta.env.MODE !== 'development') {
  // eslint-disable-next-line no-console
  console.log(
    `Build ${import.meta.env.VITE_BUILD_NUMBER ?? '?'} (${import.meta.env.VITE_COMMIT_HASH ?? '?'}) (${import.meta.env.VITE_ENV ?? '?'})`
  );
}

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found');

createRoot(container).render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <QueryClientProvider client={reactQueryUtils.client}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <AuthProvider>
              <App />
            </AuthProvider>
            <ReactQueryDevtools initialIsOpen={false} />
          </ThemeProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </Provider>
  </StrictMode>
);
